// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> cowles-landing
// Generated: 2026-10-16T14:53:21.024Z
// Counts: 3 design, 76 content, 46 slot group, 4 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span>Find Your New Home</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Studio, 1, &amp; 2 Bedroom Apartments for Rent in San Diego, CA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cowles Landing places you close to some of San Diego’s most scenic outdoor destinations. Located near Mission Trails Regional Park and the Cowles Mountain Trailhead, the community offers convenient access to hiking, recreation, neighborhood dining, and everyday essentials. It’s a setting that balances natural surroundings with practical convenience—right where you want to be.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Living Near Mission Trails and Cowles Mountain</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cowles Landing in sunny San Diego, enjoy a vibrant community with thoughtfully designed studio, 1 &amp; 2 bedroom <a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/floor-plans\"><u>floor plans</u></a>.&nbsp;</p><p></p><p>Bask in the glow of evening lights, unwind in the community pool and spa, and embrace convenient <a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/amenities\"><u>amenities</u></a> like air conditioning and reserved parking.&nbsp;<br></p><p>Lease online today and elevate your lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities at Cowles Landing reflect a thoughtful reinvestment in both comfort and design.&nbsp;</p><p><br>Select studio, one-, and two-bedroom <a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/floor-plans\"><u>apartment homes</u></a> now feature hard surface flooring, stainless steel appliances, quartz countertops, tile backsplashes, new vinyl windows, ceiling fans, and private patios—bringing a modern, refreshed feel to everyday living.&nbsp;</p><p><br>Beyond your front door, residents enjoy a pool area, landscaped grounds, and inviting outdoor spaces designed for relaxation.&nbsp;</p><p><br>Community conveniences such as reserved parking, on-site laundry facilities, a non-smoking environment, and water and trash services simplify daily routines.&nbsp;</p><p><br>With continued upgrades throughout the property, Cowles Landing is redefining apartment living near Cowles Mountain—pairing upgraded interiors with a setting known for natural beauty and <a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/neighborhood\"><u>neighborhood</u></a> comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cowles Landing, choose from thoughtfully designed studio, 1, and 2 bedroom apartments built for comfort and modern living. Have questions or want to tour one of our San Diego, CA rentals? Contact our leasing team today to explore floor plans, amenities, and find the apartment that’s right for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">At Cowles Landing in San Diego, CA, the </span><a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/gallery\"><u>ideal living space</u></a><span style=\"font-size: 16px;\"> awaits you. Choose from stylish studio, one or two-bedroom layouts, each designed for comfort and convenience. Browse our available apartment homes today to uncover the perfect floor plan that suits your lifestyle and needs in this </span><a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/neighborhood\"><u>vibrant community</u></a><span style=\"font-size: 16px;\">.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Select a floor plan below to view current availability and pricing for our Studio, 1, and 2 bedroom apartments in San Diego.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Get a feel for Cowles Landing, inside and out. Browse photos of our community exteriors and pool area, plus images of our renovated apartment interiors. With upgrades underway across the property, Cowles Landing is evolving into a refreshed </span><a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/neighborhood\"><u>San Diego living</u></a><span style=\"font-size: 16px;\"> experience near Cowles Mountain.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Cowles Landing in sunny San Diego, CA, where modern living meets serene community vibes. Choose from our stylish studio, one-bedroom, or two-bedroom floor plans. Enjoy sought-after amenities like a sparkling pool, relaxing spa, and reserved parking. Use our interactive community map to find your perfect home today!",
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cowles Landing – Where modern convenience meets the natural beauty of San Diego.</p><p></p><p>Located just minutes from Cowles Mountain Trailhead and Mission Trails Regional Park, residents have easy access to scenic trails, outdoor recreation, and expansive green space.&nbsp;</p><p></p><p>The community is also close to local dining, shopping, and everyday essentials, placing everything you need within reach.&nbsp;</p><p></p><p>Discover Cowles Landing, where location, comfort, and convenience come together.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cowles Landing in sunny San Diego, CA. Enjoy beautifully crafted apartments surrounded by lush greenery and vibrant community spaces. With pet-friendly amenities and a prime location, your ideal home awaits at Cowles Landing—where comfort and community come together seamlessly.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Set at the base of Cowles Mountain – San Diego’s highest point and one of its most iconic outdoor destinations – Cowles Landing offers a refreshed living experience surrounded by natural beauty and <a class=\"richtext-link\" href=\"/neighborhood\">neighborhood</a> comfort.</p><p>With direct access to hiking and trail running, plus proximity to Lake Murray, Mission Trails Golf Course, and the expansive Mission Trails Regional Park, the community puts the best of the outdoors right at your doorstep.</p><p>Thoughtful upgrades including refreshed exteriors, enhanced amenities, and renovated a<a class=\"richtext-link\" href=\"/floor-plans\">partment homes</a> bring a new level of comfort and style to our studio, one-, and two-bedroom residences. Discover a home defined by location, elevated by design, and connected to the best of San Diego living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cowles Landing in sunny San Diego, CA, explore thoughtfully designed studio, 1, and 2 bedroom <a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/floor-plans\"><u>apartments</u></a> tailored for you! Discover comfortable interiors and inviting <a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/amenities\"><u>community spaces</u></a> that support a vibrant lifestyle. Ready to see your next home in person? Schedule a tour today and experience all that Cowles Landing has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 16px;\">Take a virtual tour of Cowles Landing in San Diego. Explore our </span><a class=\"richtext-link\" href=\"https://www.cowleslandingapts.com/floor-plans\"><u>pet-friendly studio, 1, and 2 bedroom apartments</u></a><span style=\"font-size: 16px;\"> and see how each residence combines comfort, style, and functionality. Experience the inviting community spaces and vibrant lifestyle that make Cowles Landing a welcoming place to call home—all from the convenience of your own screen.</span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-76c5-77a8-ac56-c1d70055231a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled in a hillside community at sunset."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0ce6b-928a-7246-b6bf-6e04a581c954.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling woman enjoying a sunny pool day on a colorful unicorn float. Perfect for summer vibes."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-76c5-77a8-ac56-c1d70055231a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled in a hillside community at sunset."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-e72f-7298-9a8f-12905cc4ca0d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building entrance with lush greenery and a bench with floral cushions."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-24d0-70bf-964d-131b4c9386ab.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern white kitchen with stainless steel appliances and grey backsplash."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-2686-727f-be41-4201fcfaf1fc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment complex courtyard with swimming pool and lounge chairs."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0c9b4-8469-7597-84e0-f2a2c6975f7d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three people sit on a rocky outcrop watching a sunset over a valley."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-2372-7157-98a1-013b3adc3ca1.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-3bc8-76aa-9eb2-2ff80e01af13.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-3550-7171-b741-9e6e8d15dad4.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-5439-705c-97c1-cd17a8cfdc6c.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167016/01a0c9b2-81ef-7479-bc2a-72f4ab11014a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings nestled against a hillside with a mountain backdrop at sunset."
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0ce79-4c6f-75b8-925b-f0a98f97b1b8.webp"
      }
    }
  },
  "hero.slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0ce79-48d5-73ee-94c2-4cc2f498eac5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Family hiking with dogs on a mountain trail"
      }
    }
  },
  "hero.slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0ce79-47d3-7635-b964-431cb285f8ff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances and white cabinetry."
      }
    }
  },
  "hero.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0ce79-46f1-74e2-9fa2-4086163054a8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman meditating in a living room"
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167016/01a0c9b2-81ef-7479-bc2a-72f4ab11014a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings nestled against a hillside with a mountain backdrop at sunset."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0c9b2-8162-7258-8694-c0d70b0c9d45.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A smiling family with a dog laying on the floor."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0c9b2-81ef-7479-bc2a-72f4ab11014a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled against a hillside with a mountain backdrop at sunset."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0c9b2-8384-76f9-8fd0-0f2ac8235b6a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Girl swimming in a pool"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-76c5-77a8-ac56-c1d70055231a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled in a hillside community at sunset."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-76c5-77a8-ac56-c1d70055231a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled in a hillside community at sunset."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-3f0e-7066-872e-ad1ecb90790d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Hikers ascending a rocky trail with a dog."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-3de4-7448-833e-acaf3c1d1509.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman laughing while petting her golden retriever dog on a couch."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": 3,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-5a2f-701a-8e07-2d6e2de2e760.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0ce79-47d3-7635-b964-431cb285f8ff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances and white cabinetry."
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-3d2a-7089-9e4b-cbd697ddaa04.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-5439-705c-97c1-cd17a8cfdc6c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room and kitchen area with a couch, coffee table, dining table, and modern appliances."
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-3bc8-76aa-9eb2-2ff80e01af13.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and dining area with a large window overlooking trees"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-5995-75df-8566-f437c5b9f342.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Friends enjoying an outdoor dinner."
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-431c-72e7-bef4-f5d00b18f3a8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with mirrored closet doors and a bed with striped bedding."
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": 5,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-3d1e-73b8-98dd-8c2097d13bba.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-e72f-7298-9a8f-12905cc4ca0d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment building entrance with lush greenery and a bench with floral cushions."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167016/01a0cf0b-5995-75df-8566-f437c5b9f342.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Friends enjoying an outdoor dinner."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-76c5-77a8-ac56-c1d70055231a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled in a hillside community at sunset."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-76c5-77a8-ac56-c1d70055231a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled in a hillside community at sunset."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-76c5-77a8-ac56-c1d70055231a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled in a hillside community at sunset."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-76c5-77a8-ac56-c1d70055231a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings nestled in a hillside community at sunset."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "custom_f7f27755-ad27-41fe-9942-1f877d65c9e4",
      "custom_29ebf607-49bd-4fb9-9dcd-c6d7747a0f60",
      "custom_50804105-7dc7-4bc8-a789-7c5e5e4b0b38",
      "custom_97df3c8b-511a-4b61-8ab0-a11523eb0d4b",
      "custom_8845e652-8073-4dcc-a1ad-93dd362b83e2",
      "custom_a420a340-cbf4-46f9-b797-207ff9712528",
      "custom_c7d98390-11fb-4c79-828d-b24069f7bf6e",
      "custom_9cd1367c-0bf6-42c0-be9e-b043cc4105d9",
      "custom_9a28b1ba-131c-41e3-92fa-5d9e9aaf7361",
      "custom_ef478be1-c101-4a81-b475-c28b55d1c72c",
      "custom_160b2c8e-870b-48cc-819a-46b6c9603ec4",
      "custom_705e413d-c053-43a3-865e-4691bc59147e",
      "custom_8fb958ea-8564-4e65-a490-75be17af79cb",
      "custom_5865107b-1b0c-4139-8252-e57e7b569026",
      "custom_81291244-f967-4b12-9dfc-ec1e7a064986",
      "custom_9399f7df-df16-41fe-9f2f-d84ba6b81a7b",
      "custom_02cf8a1b-9b95-4a48-ae54-cfd3b9062637",
      "custom_9ba98d37-9dd4-408c-84a3-0823f595712c",
      "custom_03359920-9163-44e0-94b3-299b7427fde8",
      "custom_f1dea984-bf7d-4f65-b2aa-133dfa3471e5"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_676313c2-02f0-4bfb-82e5-d801eb90a3d4",
      "custom_3192cff3-4b16-4d91-bace-71efa2c7be68",
      "custom_c8d8e5aa-b4cb-4d8b-8c9f-cc3931be1310",
      "custom_2a19d612-9f23-4d9b-8dae-b4b5d7612623",
      "custom_573d65ca-c3f9-4c95-9fca-cdd66d07dbf0",
      "custom_856e9c0e-2659-4bc4-8b03-b6fcf62382ef",
      "custom_65b2225c-b593-4e81-8efa-f65f0144cbd1",
      "custom_8d58a9a7-0339-4d5e-911e-138ef02b99f0",
      "custom_b778d2c8-dfb1-4d15-b3d0-8f42ac743fc0",
      "custom_6d446fc1-0613-473a-8b37-09c4540ac0aa"
    ],
    "orderedIds": [
      "custom_e185f5ef-663d-40e4-a453-a1db19b08a9e",
      "custom_b712576d-b95e-40d1-9008-019a80213b87",
      "custom_4b38ebfe-3d0f-4da9-83d6-39b3d10c22df",
      "custom_b0c8a433-6a43-4e11-ae11-3bef70d221f5",
      "custom_990c4bbb-b9d8-44b7-afe5-8c2af60b60d0",
      "custom_b13993eb-9c80-40df-b213-6331f4df7b51",
      "custom_856e9c0e-2659-4bc4-8b03-b6fcf62382ef",
      "custom_27c1daa6-0384-4b78-8a5f-54b19cfc8ae6",
      "custom_57747fae-93a5-4439-9838-250b37e33d8b",
      "custom_2d12a71c-4101-4796-8dae-fa65bccb0474",
      "custom_7007c5fc-0142-49d7-8bd6-5da3061fe491",
      "custom_91eb6ec3-148f-4666-87ba-34516ff76ed1",
      "custom_4437af76-90dd-40d4-af9c-842f8aac979b",
      "custom_b778d2c8-dfb1-4d15-b3d0-8f42ac743fc0",
      "custom_564185e4-807d-4294-9dda-6d315899be20",
      "custom_f159f927-3d0a-431e-bdf4-10dcf050ab0e",
      "custom_6d446fc1-0613-473a-8b37-09c4540ac0aa",
      "custom_001b5bf9-4fce-403f-b01f-3277023443ac",
      "custom_1b6724bc-3a34-492f-b4ff-a97419b01a7a",
      "custom_e85e86f7-4f74-4c6f-9d5b-6c615a795251",
      "custom_726e6787-3f0b-4af4-b44f-c6a189ce15e8",
      "custom_3feef60c-92d4-42cd-992c-893a33dd6fdc",
      "custom_8c9c4aad-cc34-4ba1-a762-e316b45c54ce",
      "custom_8ac6ab1c-eaf6-401c-add0-84fb22b6bae2",
      "custom_8d58a9a7-0339-4d5e-911e-138ef02b99f0",
      "custom_29c5da66-8bfb-438b-89de-689fc52e3720",
      "custom_d5838e0e-32d5-4292-ad1a-66ca0977a7e3",
      "custom_a8c6d37b-d522-46bc-9d27-bc797625a0dc",
      "custom_5562c8c7-0c0b-4841-bf66-7b0c4d047108",
      "custom_4219ae36-6b6f-445c-a71a-eec9e85a5f66",
      "custom_65b2225c-b593-4e81-8efa-f65f0144cbd1",
      "custom_511539a7-d2bb-447d-88e9-36b29d805ede",
      "custom_2a19d612-9f23-4d9b-8dae-b4b5d7612623",
      "custom_573d65ca-c3f9-4c95-9fca-cdd66d07dbf0",
      "custom_ce8f752d-7d97-4325-a1e1-1f2844815584",
      "custom_421d6d8e-c48c-4d75-af04-96f725680802",
      "custom_12cce1b2-8280-4dde-9df5-f1d1bcc4c702",
      "custom_007e8a00-7e84-4c61-aa4f-e06af61128ff",
      "custom_a2233531-5b52-433a-afbf-f06919e8bf89",
      "custom_ed329c82-bb3d-4a76-bcf7-ee9137c60364",
      "custom_dde5daaf-9a0a-47e7-a6ea-4866d39d3186",
      "custom_6c608a88-4334-4a30-88ca-cdc298dc5966",
      "custom_e8566a5e-6a5e-4612-904a-a5002634505c",
      "custom_1859b8f8-eed4-4087-85d1-566f635da150",
      "custom_8dee4486-1fe2-4302-9c2a-28110d763f66",
      "custom_43e76ba2-240c-4db5-8f83-f52f280208eb",
      "custom_f7c21c4d-c05b-4e8b-a825-535085c87cbd",
      "custom_07c080e6-cfa1-425c-8b3d-f76a95f952ec"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
